import { useEffect, useState } from 'react'
import { Text } from '@chakra-ui/react'

const FADE_INTERVAL_MS = 1750
const WORD_CHANGE_INTERVAL_MS = FADE_INTERVAL_MS * 2
const WORDS_TO_ANIMATE = [
  'Hello',
  'Ciao',
  'Jambo',
  'Bonjour',
  'Salut',
  'Hola',
  'Nǐ hǎo',
  'Hallo',
  'Hej',
  '👋🏻',
]

const AnimatedText = () => {
  const [fadeProp, setFadeProp] = useState({ fade: 'fade-in' })
  const [wordOrder, setWordOrder] = useState(0)

  useEffect(() => {
    const fadeTimeout = setInterval(() => {
      setFadeProp((prevFadeProp) => ({
        fade: prevFadeProp.fade === 'fade-in' ? 'fade-out' : 'fade-in',
      }))
    }, FADE_INTERVAL_MS)

    return () => clearInterval(fadeTimeout)
  }, [fadeProp])

  useEffect(() => {
    const wordTimeout = setInterval(() => {
      setWordOrder(
        (prevWordOrder) => (prevWordOrder + 1) % WORDS_TO_ANIMATE.length
      )
    }, WORD_CHANGE_INTERVAL_MS)

    return () => clearInterval(wordTimeout)
  }, [])

  return (
    <h2>
      <span className={fadeProp.fade}>{WORDS_TO_ANIMATE[wordOrder]}</span>,{' '}
      <Text
        as='span'
        fontWeight='extrabold'
        fontSize={{
          base: '30px',
          sm: '30px',
          md: '45px',
          lg: '45px',
          xl: '45px',
        }}
        color='Olive'>
        Bintus{' '}
      </Text>
      HERE!
    </h2>
  )
}

export default AnimatedText
